import { render, staticRenderFns } from "./MarginHealPopup.vue?vue&type=template&id=59f4be5a&scoped=true&"
import script from "./MarginHealPopup.vue?vue&type=script&lang=js&"
export * from "./MarginHealPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarginHealPopup.vue?vue&type=style&index=0&id=59f4be5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4be5a",
  null
  
)

export default component.exports